import { createUseStyles } from 'react-jss'

import { lightGrey } from '../../styles/const/colors'
import { defaultBorderRadius } from '../../styles/const/common'
import { phonesDown } from '../../styles/const/breakpoints'

export default createUseStyles(theme => ({
  timePicker: {
    width: '100% !important',
    height: 40,
    background: 'white',
    padding: '0 11px 0 13px',
    outline: 'none',
    appearance: 'none',
    border: {
      width: 1,
      style: 'solid',
      color: lightGrey,
      radius: defaultBorderRadius
    },
    '&:focus': {
      borderColor: theme.brandPrimary
    },
    '&:disabled': {
      background: lightGrey
    }
  },
  [`@media screen and (${phonesDown})`]: {
    timePicker: {
      height: 34,
      fontSize: 12
    }
  }
}))
